export class APIKeys extends HTMLElement {
  constructor(data, is_admin) {
    super();
    this.data = data;
    this.is_admin = is_admin;
  }

  connectedCallback() {
    this.innerHTML =
      `
      <div class="col-sm-12" style="display:flex; justify-content: space-between; margin-bottom: 10px;">
        <h3>API Keys</h3>
        ${this.is_admin ? '<button class="btn btn-primary pull-right" id="create_api_btn">Create API Key</button>' : ''}
      </div>



      
      <table id="api_keys" class="table" style="width:100%">
          <thead>
            <tr>
              <th>Description</th>
              <th>Name</th>
              <th>Expiration Date</th>
              <th>Edit</th>
            </tr>
          </thead>
      </table>
      `;

    this.init();

    $('#api_keys tbody').on('click', 'button.edit_api_key', function(e) {
      let tr  = $(e.target).closest('tr')
      let rowObject = this.table.row(tr);
      let apiKey = rowObject.data();
      this.viewToken(apiKey, rowObject)
    }.bind(this))

    if(this.is_admin) {
      this.querySelector('#create_api_btn').addEventListener('click', function() {
        this.hide();
        this.closest('#api_keys_tab').appendChild(new CreateAPIKey(this.reloadRow.bind(this)));
      }.bind(this))
    }
  }

  init() {
    this.table = $('#api_keys').DataTable({
      "data": this.data.api_tokens,
      "columns": [
        { "data": "description" },
        { "data": "partial_api_token" },
        { 
          "data": "expiration_date",
          "render": function(data, type, row) {
            return data ? moment(data).format('L') : '';
          },
          "class": "text-center"
        },
        {
          "render": function(data, type, row) {
            return `<button class="btn btn-outline-secondary edit_api_key">Edit</button>`;
          },
          "class": "text-center"
        },
      ],
    });
  }

  viewToken(key, rowObject) {
    this.hide();
    this.closest('#api_keys_tab').appendChild(new EditAPIKey(key, rowObject, this.reloadRow.bind(this)));
  }

  reloadRow(data, rowObject, action=null) {
    if(action=="remove") {
      rowObject
        .remove()
        .draw();
    } else if (action=="add") {
      this.table
        .row.add(data)
        .draw();
    } else {
      this.table.row(rowObject).data(data)
    }
  }

  show() {
    this.classList.remove('hidden');
  }

  hide() {
    this.classList.add('hidden');
  }
}

customElements.define('api-keys', APIKeys)

class EditAPIKey extends HTMLElement {
  constructor(data, rowObject, reloadRow) {
    super();
    this.data = data;
    this.rowObject = rowObject;
    this.reloadRow = reloadRow;
  }

  async connectedCallback() {
    this.group_id = document.getElementById('object_id').value;

    let res_all = await fetch(`/admin/api_endpoints`);
    let json_all = await res_all.json();

    let res = await fetch(`/admin/groups/${this.group_id}/api_tokens/${this.data.id}/api_endpoints`);
    let json = await res.json();
    let selectedEndpoints = json.endpoints.map(e => {return e.endpoint_id});

    let endpoints = json_all.endpoints.map(e => {
      if(e.endpoint_path != "null") {
        return `<tr><td class="text-center api_key_table_cell"><input type="checkbox" class="endpoint" value="${e.endpoint_id}" ${selectedEndpoints.includes(e.endpoint_id) ? 'checked' : ''}></td><td class="api_key_table_cell">${e.endpoint_path}</td><td>${e.notes ? e.notes : ''}</td></tr>`
      }
    }).join('')
    this.innerHTML =
      `
      <style>
        edit-api-key input {
          margin-bottom: 10px;
        }

        .api_key_button_row {
          margin-top: 20px;
        }

        #api_endpoints {
          padding: 20px;
        }

        edit-api-key .panel {
          width: 58.33333333%;
          margin-left: 10px;
        }

        .api_key_table_cell {
          padding-right: 20px;
        }
      </style>
      <div class="row">
        <div class="col-md-12">
          <h3><span id="api_key_back"></span> Edit API Key</h3>
        </div>
        <div class="errors"></div>
        <div class="col-md-12">
          <label>${this.data.partial_api_token}</label>
        </div>
        <div class="col-md-7">
          <label>Description</label>
          <input type="text" class="form-control" id="api_key_description" value="${this.data.description ? this.data.description : ''}">
          <div class="api_key_flex">
            <label>Set Expiration Date</label>
            <input type="checkbox" id="api_key_expiration_checkbox" ${this.data.expiration_date ? 'checked' : ''}>
          </div>
        </div>
        <div class="col-md-7 ${!this.data.expiration_date ? 'hidden' : ''}" id="api_key_expiration_date_container">
          <input type="text" class="form-control" id="api_key_expiration_date" value="${this.data.expiration_date ? moment(this.data.expiration_date).format('L') : moment().add(6,'months').format('L')}">
        </div>
        <div class="col-md-7" id="api_endpoints">
          <h4>Select API Endpoints</h4>
          <p>Select the API Endpoints you want this token to have access to.</p>
          <table>
            <tbody>
              ${endpoints}
            </tbody>
          </table>
        </div>
        <div class="col-sm-12 api_key_button_row">
          <button class="btn btn-outline-danger" id="api_key_delete">Delete</button>
          <button class="btn btn-primary pull-right campaign-row-button" id="save_edit_api_key" data-cy="save_edit_api_key">Save</button>
          <button class="btn btn-outline-secondary pull-right campaign-row-button cancel">Cancel</button>
        </div>
      </div>
      `;

    this.querySelector('#api_key_back').addEventListener('click', this.cancelEdit.bind(this));
    this.querySelector('.cancel').addEventListener('click', this.cancelEdit.bind(this));
    this.querySelector('#save_edit_api_key').addEventListener('click', this.save.bind(this));
    this.querySelector('#api_key_delete').addEventListener('click', this.delete.bind(this));

    this.querySelector('#api_key_expiration_checkbox').addEventListener('click', function() {
      if(this.querySelector('#api_key_expiration_checkbox').checked) {
        this.querySelector('#api_key_expiration_date_container').classList.remove('hidden');
      } else {
        this.querySelector('#api_key_expiration_date_container').classList.add('hidden');
      }
    }.bind(this))

    this.cancellation_date = moment().add(1, "days").format('YYYY-MM-DD');
    $(this).find("#api_key_expiration_date").daterangepicker(
      {
        autoApply: true,
        minDate: moment().add(1,'days'),
        singleDatePicker: true
      },
      function (start) {
        this.cancellation_date = start.startOf("day").format('YYYY-MM-DD');
      }.bind(this)
    );
  }

  cancelEdit() {
    this.remove();
    document.querySelector('api-keys').show();
  }

  async save() {
    if(this.validate()) {
      let data = {
        description: this.querySelector('#api_key_description').value,
        expiration_date: this.querySelector('#api_key_expiration_checkbox').checked ? this.cancellation_date : null,
        endpoints: Array.from(this.querySelectorAll('.endpoint')).map(e => {return {value: e.value, checked: e.checked}})
      }

      let res = await fetch(`/admin/groups/${this.group_id}/api_tokens/${this.data.id}`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'PUT',
        body: JSON.stringify(data)
      })

      if (!res.ok) // or check for response.status
          throw new Error(res.statusText);
      
      let response = await res.json();

      if(response.success) {
        Common.notify('Updated API Key', 'success');
        this.reloadRow(response.token, this.rowObject)
        this.cancelEdit()
      }
      else Common.notify('Failed to update API Key', 'error');

    }
  }

  validate() {
    this.querySelectorAll('.error').forEach(elem => {
      elem.classList.remove('error');
    })
    let isValid = true;

    if(!this.querySelector('#api_key_description').value) {
      this.querySelector('.errors').innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong>Warning!</strong> Please provide a description.
                                                  </div>`;

      this.querySelector('#api_key_description').classList.add('error');
      isValid = false;
    }

    return isValid
  }

  async delete() {
    if(await confirmPlus("Are you sure you want to delete this API Key?")) {
      let res = await fetch(`/admin/api_tokens/${this.data.id}/api_tokens`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'DELETE'
      })
  
      let response = await res.json();
      if(res.ok) {
        Common.notify('API Key deleted', 'success');
        this.reloadRow(null, this.rowObject, "remove");
        this.cancelEdit();
      } else {
        console.log("UNABLE TO DELETE")
      }
    }
  }
}

customElements.define('edit-api-key', EditAPIKey)

class CreateAPIKey extends HTMLElement {
  constructor(reloadRow) {
    super();
    this.reloadRow = reloadRow;
  }

  async connectedCallback() {
    this.group_id = document.getElementById('object_id').value;
    let res = await fetch(`/admin/api_endpoints`);
    let json = await res.json();
    let endpoints = json.endpoints.map(e => {
      if(e.endpoint_path != "null") {
        return `<tr><td class="text-center api_key_table_cell"><input type="checkbox" class="endpoint" value="${e.endpoint_id}"></td><td class="api_key_table_cell">${e.endpoint_path}</td><td>${e.notes ? e.notes : ''}</td></tr>`
      }
    }).join('')

    this.innerHTML =
      `
      <style>
        create-api-key input {
          margin-bottom: 10px;
        }

        #api_endpoints {
          padding: 20px;
        }

        create-api-key .panel {
          width: 58.33333333%;
          margin-left: 10px;
        }

        .api_key_table_cell {
          padding-right: 20px;
        }
      </style>
      <div class="row create_api_key_form">
        <div class="col-md-12">
          <h3><span id="api_key_back"></span> Create API Key</h3>
        </div>
        <div class="api_key_display hidden">
          <div class="alert alert-info alert-dismissible show col-md-12">
            <p id="copy_token_text">Token Here</p>
            <span>Copy this token for you records. It will be unavailable after closing this window.</span>
            <button class="btn btn-outline-primary" id="copy_token_button"><i class="fa fa-clipboard" aria-hidden="true"></i> Copy</button>
          </div>
        </div>
        <div class="errors"></div>
        <div class="col-md-7">
          <label>Description</label>
          <input type="text" class="form-control" id="create_api_key_description">
          <div class="api_key_flex">
            <label>Set Expiration Date</label>
            <input type="checkbox" id="create_api_key_expiration_checkbox">
          </div>
        </div>
        <div class="col-md-7 hidden" id="create_api_key_expiration_date_container">
          <input type="text" class="form-control" id="create_api_key_expiration_date">
        </div>
        <div class="col-md-7" id="api_endpoints">
          <h4>Select API Endpoints</h4>
          <p>Select the API Endpoints you want this token to have access to.</p>
          <table>
            <tbody>
              ${endpoints}
            </tbody>
          </table>
        </div>
        <div class="col-sm-12">                                                                        
          <button class="btn btn-primary pull-right campaign-row-button" id="save_create_api_key" data-cy="save_create_api_key">Save</button>
          <button class="btn btn-outline-secondary pull-right campaign-row-button cancel">Cancel</button>
        </div>
      </div>
      `;

    this.querySelector('#api_key_back').addEventListener('click', this.cancel.bind(this));
    this.querySelector('.cancel').addEventListener('click', this.cancel.bind(this));
    this.querySelector('#save_create_api_key').addEventListener('click', this.save.bind(this));
    this.querySelector('#copy_token_button').addEventListener('click', function(e) {
      this.copyToken(e)
    }.bind(this));

    this.querySelector('#create_api_key_expiration_checkbox').addEventListener('click', function() {
      if(this.querySelector('#create_api_key_expiration_checkbox').checked) {
        this.querySelector('#create_api_key_expiration_date_container').classList.remove('hidden');
      } else {
        this.querySelector('#create_api_key_expiration_date_container').classList.add('hidden');
      }
    }.bind(this))

    this.cancellation_date = moment().add(1, "days").format('YYYY-MM-DD');
    $(this).find("#create_api_key_expiration_date").daterangepicker(
      {
        autoApply: true,
        minDate: moment().add(1,'days'),
        singleDatePicker: true
      },
      function (start) {
        this.cancellation_date = start.startOf("day").format('YYYY-MM-DD');
      }.bind(this)
    );
  }

  cancel() {
    this.remove();
    document.querySelector('api-keys').show();
  }

  async save() {
    if(this.validate()) {
      let data = {
        description: this.querySelector('#create_api_key_description').value,
        expiration_date: this.querySelector('#create_api_key_expiration_checkbox').checked ? this.cancellation_date : null,
        endpoints: Array.from(this.querySelectorAll('.endpoint:checked')).map(e => {return e.value})
      }

      let res = await fetch(`/admin/groups/${this.group_id}/api_token`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'POST',
        body: JSON.stringify(data)
      })

      if (!res.ok) // or check for response.status
          throw new Error(res.statusText);
      
      let response = await res.json();

      if(response.success) {
        Common.notify('API Key created', 'success');
        this.querySelector('#copy_token_text').innerText = response.new_token;
        this.querySelector('.api_key_display').classList.remove('hidden');
        document.getElementById('group_management_body').scrollTo(0, 0);
        this.reloadRow(response.token, null, "add");
      }
      else Common.notify('Failed to create API Key', 'error');

    }
  }

  validate() {
    return true
  }

  copyToken(e) {
    e.target.focus();
    let tempInput = document.createElement("input");
    let copyText = this.querySelector('#copy_token_text').innerText;
    tempInput.value = copyText;
    document.body.appendChild(tempInput);
    tempInput.select();

    // Copy the text inside the text field
    navigator.clipboard.writeText(tempInput.value);
    Common.notify('Copied to clipboard', 'success');
    document.body.removeChild(tempInput);
  }
}

customElements.define('create-api-key', CreateAPIKey)